import React, {Component} from 'react';
import {connect} from 'react-redux';
import {Card} from 'semantic-ui-react';
import {
  ResponsiveContainer, ComposedChart, Line, Bar, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ReferenceLine,
} from 'recharts';

const newColors = {
  'orange': '#E8A876',
  'blue': '#194182',
  'red': '#C43100',
  'teal': '#29C4B2',
  'purpleLigth': '#5F64C0',
};

class ComposedChartInPartWatching extends Component {
  getFormattedData() {
    const {data} = this.props;
    const sales = data.sales;
    const onHand = data.onHand;
    const onOrders = data.onOrders;
    const receptions = data.receptions;
    const backOrders = data.backOrders;
    const result = [];

    sales.forEach((element, index) => {
      result.push({
        'name': `${element.month}-${element.year}`,
        'month': element.month,
        'year': element.year,
        'sales': element.quantity,
        'onHand': onHand[index].quantity,
        'onOrders': onOrders[index].quantity,
        'receptions': receptions[index].quantity,
        'backOrders': backOrders[index].quantity,
      });
    });

    return result;
  }

  handleOnOrdersClick(data) {
    this.props.activeOnOrdersBarClick(data.year, data.month);
  }

  handleReceptionsClick(data) {
    this.props.activeReceptionsBarClick(data.year, data.month);
  }

  renderSalesActiveDot({cx, cy, value, payload}) {
    return (
      <g>
        <circle
          r={4}
          stroke='#47CBFF'
          strokeWidth={1}
          fill='white'
          cx={cx}
          cy={cy}
          onClick={this.props.activeSaleLineClick.bind(
            this,
            payload.year,
            payload.month
          )}
        />
      </g>
    );
  }

  renderOnOrdersBar() {
    const {type} = this.props;
    if (type === 'sales') {
      return (
        <Bar
          type='monotone'
          dataKey='onOrders'
          fill={newColors.orange}
          stroke={newColors.orange}
          name='O/O'
          onClick={this.handleOnOrdersClick.bind(this)}
        />
      );
    }
    return null;
  }

  renderReceptionsBar() {
    const {type} = this.props;
    if (type === 'sales') {
      return null;
    }
    return (
      <Bar
        type='monotone'
        dataKey='receptions'
        fill={newColors.teal}
        stroke={newColors.teal}
        name='Recibido'
        onClick={this.handleReceptionsClick.bind(this)}
      />
    );
  }

  renderBackOrdersBar() {
    const {type} = this.props;
    if (type === 'sales') {
      return null;
    }
    return (
      <Bar
        type='monotone'
        dataKey='backOrders'
        fill={newColors.purpleLigth}
        stroke={newColors.purpleLigth}
        name='B/O'
      />
    );
  }

  renderSalesLine() {
    const {type} = this.props;
    if (type === 'sales') {
      return (
        <Line
          dataKey='sales'
          stroke={newColors.red}
          name='Ventas'
          strokeWidth={4}
          activeDot={this.renderSalesActiveDot.bind(this)}
        />
      );
    }
    return null;
  }

  renderOnOrdersLine() {
    const {type} = this.props;
    if (type === 'sales') {
      return null;
    }
    return (
      <Bar
        type='monotone'
        dataKey='onOrders'
        fill={newColors.orange}
        stroke={newColors.orange}
        name='O/O'
      />
    );
  }

  renderReferenceLine() {
    const {referenceLine} = this.props;
    if (!referenceLine) {
      return null;
    }
    return <ReferenceLine x={referenceLine} stroke='red' />;
  }

  render() {
    const {loading, data} = this.props;
    if (loading || !data || !data.sales || !data.sales.length) {
      return null;
    }

    const dataFormmatted = this.getFormattedData();

    return (
      <Card fluid raised>
        <ResponsiveContainer width='100%' height={350}>
          <ComposedChart
            data={dataFormmatted}
            margin={{'top': 15, 'right': 25, 'bottom': 5, 'left': 5}}
          >
            <CartesianGrid stroke='#f5f5f5' />
            <XAxis dataKey='name' />
            <YAxis />
            <Tooltip />
            <Legend />
            {this.renderOnOrdersBar()}
            {this.renderReceptionsBar()}
            {this.renderBackOrdersBar()}
            {this.renderSalesLine()}
            {this.renderOnOrdersLine()}
            {this.renderReferenceLine()}
            <Line
              type='monotone'
              dataKey='onHand'
              stroke={newColors.blue}
              strokeWidth={2}
              name='O/H'
            />
          </ComposedChart>
        </ResponsiveContainer>
      </Card>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    'loading': state.partWatching.loading,
    'data': state.partWatching.partWatching,
  };
};

export default connect(mapStateToProps, {
})(ComposedChartInPartWatching);
